import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#272A38] bg-[#0B0C10]">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="font-display text-3xl font-black uppercase italic text-[#F3F4F6]">Delta</span>
              <span className="font-display text-3xl font-black uppercase italic text-[#F59E0B]">R.E.M.</span>
              <span className="font-display text-3xl font-black uppercase italic text-[#F3F4F6]">S.r.l.</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#6B7280]">
              Autodemolizione e vendita online di motori usati testati e verificati.
              Da Cremona, in tutta Italia.
            </p>
          </div>

          <div className="mono space-y-3 text-xs uppercase tracking-widest text-[#9CA3AF]">
            <p className="font-display text-lg font-bold uppercase tracking-wide text-[#F3F4F6]">Contatti</p>
            <a data-testid="footer-phone-link" href="tel:+393510741289" className="flex items-center gap-3 transition-colors duration-300 hover:text-[#F59E0B]">
              <Phone className="h-3.5 w-3.5 text-[#F59E0B]" /> Tel / WhatsApp: 351 074 1289
            </a>
            <a data-testid="footer-email-link" href="mailto:info.deltademolizioni@gmail.com" className="flex items-center gap-3 transition-colors duration-300 hover:text-[#F59E0B]">
              <Mail className="h-3.5 w-3.5 text-[#F59E0B]" /> info.deltademolizioni@gmail.com
            </a>
            <a
              data-testid="footer-address-link"
              href="https://maps.google.com/?q=Via+dei+Cipressi+1G+26100+Cremona"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 transition-colors duration-300 hover:text-[#F59E0B]"
            >
              <MapPin className="h-3.5 w-3.5 text-[#F59E0B]" /> Via dei Cipressi, 1/G — 26100 Cremona (CR)
            </a>
          </div>

          <div className="mono space-y-3 text-xs uppercase tracking-widest text-[#9CA3AF]">
            <p className="font-display text-lg font-bold uppercase tracking-wide text-[#F3F4F6]">Dati societari</p>
            <p>Delta - R.E.M. S.r.l.</p>
            <p>Via dei Cipressi, 1/G</p>
            <p>26100 Cremona (CR) — Italia</p>
            <p data-testid="footer-vat">P.IVA 01232460335</p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-[#272A38] pt-6 sm:flex-row">
          <p className="mono text-[10px] uppercase tracking-widest text-[#6B7280]">
            © {new Date().getFullYear()} Delta - R.E.M. S.r.l. — Tutti i diritti riservati
          </p>
          <p className="mono text-[10px] uppercase tracking-widest text-[#6B7280]">
            Motori usati testati e verificati
          </p>
        </div>
      </div>
    </footer>
  );
}
